import { IComponentOptions, Injectable, IOnInit, IScope } from "angular";
import { upperFirst } from "lodash";
import { ProcessApiResponse } from "../../../../model/ProcessApi";
import {
  ProcessInformation,
  ProcessStateMetadataInformation,
} from "../../../../model/ProcessGroups";

export interface ProcessTimelineDetailComponentConfig<
  TData = unknown,
  TController extends ProcessTimelineDetailComponentController<TData> =
    ProcessTimelineDetailComponentController<TData>,
> {
  controller?: Injectable<(...args: any[]) => TController>;
  controllerAs?: string;
  template: string;
}

export function getComponentName(componentName: string): string {
  const result = `processTimeDetail${upperFirst(componentName)}`;
  return result;
}

export function getProcessTimelineDetailComponent<
  TData = unknown,
  TController extends ProcessTimelineDetailComponentController<TData> =
    ProcessTimelineDetailComponentController<TData>,
>(
  config: ProcessTimelineDetailComponentConfig<TData, TController>,
): IComponentOptions {
  return {
    controllerAs: config.controllerAs ?? "ctrl",
    controller:
      config.controller ?? ProcessTimelineDetailComponentController<TData>,
    template: config.template,
    bindings: {
      model: "<",
      context: "<",
    },
  };
}

export class ProcessTimelineDetailComponentController<
  TData,
> implements IOnInit {
  static $inject: string[] = [];
  constructor() {}

  /* bindings */
  model!: TData;
  context?: {
    process: ProcessApiResponse<unknown>;
    processInformation: ProcessInformation;
  };

  /* end Bindings */

  $onInit(): void {}

  protected getStateById(
    id: string,
  ): ProcessStateMetadataInformation | undefined {
    return this.context?.processInformation.States.find((s) => s.Id === id);
  }
}
